import { useRef } from "react";
import Layout from "../components/Layout";
import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { Mesh, MeshStandardMaterialParameters } from "three";

const GridFloor = () => {
  return (
    <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -1, 0]} receiveShadow>
      <planeGeometry args={[10, 10]} />{" "}
      <meshStandardMaterial color={0xffffff} />
    </mesh>
  );
};

interface MyMeshStandardMaterialParameters
  extends MeshStandardMaterialParameters {
  receiveShadow: boolean;
}

const RotatableCube = () => {
  // const [rotation, setRotation] = useState<[number, number, number]>([0, 0, 0]);
  const cubeRef = useRef<Mesh | null>(null);

  const materialProps: MyMeshStandardMaterialParameters = {
    color: "yellow",
    metalness: 0.8,
    roughness: 0.4,
    emissive: "red",
    emissiveIntensity: 0.2,
    receiveShadow: true,
  };

  return (
    <mesh ref={cubeRef} castShadow>
      <boxGeometry args={[3, 3, 3]} />
      <meshStandardMaterial {...materialProps} />
    </mesh>
  );
};

const Home = () => {
  return (
    <Layout activeLink="Home">
      <div className="canvas-container">
        <Canvas>
          <ambientLight />
          <pointLight position={[10, 10, 10]} castShadow />
          <GridFloor />
          <RotatableCube />
          <OrbitControls />
        </Canvas>
      </div>
    </Layout>
  );
};

export default Home;
